// removed by extract-text-webpack-plugin
module.exports = {"main":"GvlV9g8t2uIDH159uzjSo","registerResidentWorkersDialog":"_1y-dqJNiRm5iFJwx5pPnNZ","registrationCompleteDialog":"_2oJguI8gjBQ4uRv3LJYLSH","updateStatusDialog":"_22nciU9CDyg4jBba2afckM","search":"_1lwiU5deh73Sh2eHqAqEuA","spotWorkersTable":"kSprQi_E2ROd8AROudw0E","toopTip":"WlfzH5P9DidcDF1MAP-tm","imageUploadDialog":"_1GgTUtvPuSlSti21pnm495","deleteSpotWorkersDialog":"_2beIIjOYjqK6OGYYV1HzfN"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/spotWorkers/spotWorkers.scss
// module id = 587
// module chunks = 0